import { render, staticRenderFns } from "./TheLeftPanel.vue?vue&type=template&id=7872477e"
import script from "./TheLeftPanel.vue?vue&type=script&lang=ts"
export * from "./TheLeftPanel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports